import React, { useState } from 'react';
import axios from '../api/axiosConfig';
import './Modal.css';

const CargarLiquidacionModal = ({ isOpen, onClose, tramite, onSuccess }) => {
  const [file, setFile] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen || !tramite) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setError('El documento de liquidación es obligatorio.');
      return;
    }

    setLoading(true);
    setError('');

    const formData = new FormData();
    formData.append('liquidacion_file', file);
    formData.append('tramite_id', tramite.id);

    try {
      const response = await axios.post(`/api/tramites/${tramite.id}/cargar-liquidacion`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      alert(response.data.message || 'Liquidación cargada exitosamente');
      onSuccess();
      onClose();
      setFile(null);

    } catch (err) {
      console.error('Error al cargar liquidación:', err);
      alert(err.response?.data?.message || 'Error al cargar la liquidación');
      setError(err.response?.data?.message || 'Error al cargar la liquidación');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '500px' }}>
        <div className="modal-header">
          <h3>📄 Adjuntar Liquidación - Trámite #{tramite.id}</h3>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form" style={{ padding: '20px 0' }}>
          {error && <div className="error-banner" style={{ marginBottom: '15px' }}>{error}</div>}
          
          <div className="info-card" style={{ background: '#f8fafc', padding: '15px', borderRadius: '10px', marginBottom: '20px', border: '1px solid #e2e8f0' }}>
            <p style={{ margin: '0 0 5px 0', fontSize: '14px' }}><strong>Propietario:</strong> {tramite.datos_adicionales?.propietario}</p>
            <p style={{ margin: '0 0 5px 0', fontSize: '14px' }}><strong>Placa:</strong> <span className="plate-badge-sm">{tramite.datos_adicionales?.placa_referencia || 'N/A'}</span></p>
            <p style={{ margin: '0', fontSize: '14px' }}><strong>Tránsito:</strong> <span style={{ background: '#e0e7ff', color: '#3730a3', padding: '2px 10px', borderRadius: '6px', fontWeight: '600', fontSize: '13px' }}>{tramite.transito_name || 'N/A'}</span></p>
          </div>

          <div className="form-group" style={{ marginTop: '15px' }}>
            <label>Documento de Liquidación: <span style={{ color: '#ef4444' }}>*</span></label>
            <input 
              type="file" 
              accept=".pdf,.png,.jpg,.jpeg" 
              onChange={(e) => setFile(e.target.files[0])} 
              required
              style={{ padding: '10px', background: '#f1f5f9', borderRadius: '8px', border: '1px dashed #cbd5e1', width: '100%' }}
            />
            <small style={{ color: '#64748b', display: 'block', marginTop: '5px' }}>Puede adjuntar PDF o imágenes (PNG, JPG).</small>
          </div>

          <div className="modal-actions" style={{ marginTop: '30px' }}>
            <button type="button" className="btn-secondary" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
            <button type="submit" className="btn-primary" disabled={loading} style={{ background: '#10b981', borderColor: '#059669' }}>
              {loading ? '⏳ Subiendo...' : '🚀 Adjuntar Documento'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CargarLiquidacionModal;
